<template>
    <div class="row">
        <div class="col-12">
            <table class="table">
                <thead>
                    <tr>
                        <th>{{ uLang('app.description') }}</th>
                        <th>{{ uLang('app.current_file_name') }}</th>
                        <th>{{ uLang('app.uploaded_at') }}</th>
                        <th>{{ uLang('app.upload_file') }}</th>
                    </tr>
                </thead>
                <tbody>
                    <!-- Here just add all the files -->
                    <tr v-for="file in files">
                        <td>{{ file.description === null ? '-' : file.description }}</td>
                        <td>
                            <span @click="showFile(file)" class="text-brand cursor-pointer">
                                {{ file.name + '.' + file.extension }}
                            </span>
                        </td>
                        <td>{{ file.created_at | dateForHumans }}</td>
                        <td>
                            <file-upload
                                v-if="$can('update-files')"
                                :entityType="entityType"
                                :entityId="entityId"
                                :allowDescription="true"
                                @updateSuccess="onFileUpdateSuccess"
                                @uploadSuccess="onFileUpdateSuccess"
                                @uploadFailed="onFileUpdateFailed"
                                :documentId="file.id"
                            />
                        </td>
                        <td>
                            <document-edit-button
                                v-if="$can('update-files')"
                                :file="file"
                                @updateSuccess="onFileUpdateSuccess"
                            />
                            <file-delete
                                v-if="$can('delete-files')"
                                @deleteSuccess="onFileDeleteSuccess"
                                @deleteFailed="onFileDeleteFailed"
                                :documentId="file.id"
                            />
                        </td>
                    </tr>

                    <!-- Empty table row -->
                    <tr v-if="!documentTypes.length && !files.length">
                        <td colspan="4">{{ uLang('app.there_are_no_required_documents') }}</td>
                    </tr>
                </tbody>
            </table>
            <portal to="modals" v-if="showDocument">
                <b-modal
                    v-model="showDocument"
                    :hideFooter="true"
                    :title="uLang('app.document')"
                    size="xl"
                >
                    <file-preview height="80vh" :url="downloadPath(entityType, entityId, clickedFile.id)"/>
                </b-modal>
            </portal>
        </div>
    </div>
</template>

<script>
    import { DocumentEditButton, FileUpload, FileDelete } from "~/components/tabs/documents"
    import FileUpdate from './file-update';

    export default {
        components: { DocumentEditButton, FileUpload, FileDelete },
        mixins: [FileUpdate],
        name: "documents-table",
        props: {
            entityType: {
                type: String,
                required: true,
            },
            entityId: {
                type: Number,
                required: true,
            },
            files: {
                type: Array,
                default: () => [],
                required: false,
            },
        },

        data() {
            return {
                documentTypes: [],
                clickedFile: null,
                showDocument: false,
            }
        },

        methods: {
            async retrieveDocumentTypes() {
                const { data } = await window.axios.get(route('resource.document_type.index', {
                    resource: this.entityType,
                    resource_id: this.entityId,
                }))

                this.documentTypes = data;
            },

            onDocumentTypeUploadSucceeded(data, documentTypeId) {
                let updatedDocumentType = null;
                this.documentTypes = this.documentTypes.map((documentType) => {
                    if (documentType.id === documentTypeId) {
                        documentType.files[0] = data;

                        updatedDocumentType = documentType;
                    }

                    return documentType;
                });

                swal({
                    'title': this.uLang('app.success'),
                    'text': this.uLang('app.file_has_been_successfully_saved', {
                        document_type: updatedDocumentType.description.toLowerCase(),
                        file_name: '"' + data.name + '.' + data.extension + '"'
                    }),
                    'icon': 'success',
                });
            },

            onDocumentTypeUploadFailed(errors) {
                swal({
                    'title': this.uLang('app.oops_something_went_wrong'),
                    'text': errors.file[0],
                    'icon': 'error',
                });
            },

            onFileUpdateSuccess(data) {
                this.$emit('fileUpdated', data)
            },

            onFileDeleteSuccess() {
                this.$emit('fileDeleted')
            },

            onFileDeleteFailed(errors) {
                swal({
                    'title': this.uLang('app.oops_something_went_wrong'),
                    'text': errors[0],
                    'icon': 'error',
                });
            },

            onFileUpdateFailed(errors) {
                swal({
                    'title': this.uLang('app.oops_something_went_wrong'),
                    'text': errors.file[0],
                    'icon': 'error',
                });
            },

            downloadPath(entityType, entityId, fileId) {
                return route('resource.files.show', {
                    file: fileId,
                }) +'#navpanes=0';
            },

            onFileMetaDataUpdated(file) {
                this.onFileUpdateSuccess(file);
            },

            showFile(file) {
                this.clickedFile = file;
                if (this.clickedFile.extension === 'zip') {
                    window.location.href = this.downloadPath(this.entityType, this.entityId, this.clickedFile.id)
                    return;
                }

                this.showDocument = true;
            }

        },
    }
</script>

<style scoped>
    .file-description {
        border-bottom: 1px dotted #000;
        text-decoration: none;
        cursor: pointer;
    }
</style>
